module.exports = __webpack_public_path__ + "static/media/Group 1602.c36fbca8.svg";